<template>
  <el-popover
    placement="bottom"
    trigger="hover"
    :open-delay="200"
    popper-class="mini-app-qrcode-popover"
  >
    <div v-if="loading" class="qrcode-list"><span class="loading-text">加载中...</span></div>
    <div v-else-if="list.length === 0" class="qrcode-list"><span class="loading-text">暂无小程序</span></div>
    <div v-else class="qrcode-list">
      <div
        v-for="item in list"
        :key="item.name"
        class="qrcode-item"
        @click="showPreview(item)"
      >
        <img :src="item.qrcodeImg" :alt="item.name" class="qrcode-img" />
        <span class="qrcode-name">{{ item.name }}</span>
      </div>
    </div>
    <slot name="trigger" slot="reference" :list="list" />

    <el-dialog
      :visible.sync="dialogVisible"
       append-to-body center
      width="360px"
      top="20vh"
    >
      <div class="preview-body">
        <img v-if="selectedItem" :src="selectedItem.qrcodeImg" class="preview-img"/>
        <span v-if="selectedItem" class="preview-name">{{ selectedItem.name }}</span>
      </div>
    </el-dialog>
  </el-popover>
</template>

<script>
import { getMiniAppList } from '@/api/open/app'

export default {
  name: 'MiniAppQrCode',
  data() {
    return {
      list: [],
      loading: false,
      dialogVisible: false,
      selectedItem: null
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    async fetchList() {
      this.loading = true
      try {
        const data = await getMiniAppList()
        this.list = (data || []).map(item => ({ name: item.wxAppName, qrcodeImg: item.wxAppQrCode })).filter(item => item.qrcodeImg)
      } catch {
        this.list = []
      } finally {
        this.loading = false
      }
    },
    showPreview(item) {
      this.selectedItem = item
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped lang=scss>
/deep/.el-dialog .el-dialog__header {
    border: none !important;
    background: #fff !important;
}
.qrcode-list {
  display: flex;
  gap: 16px;
  padding: 4px 0;
}
.qrcode-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}
.loading-text {
  font-size: 12px;
  color: #999;
  padding: 8px 0;
}
.qrcode-img {
  width: 100px;
  height: 100px;
  border-radius: 4px;
  border: 1px solid transparent;
  transition: all 0.2s ease;
  margin-bottom: 4px;
}
.qrcode-item:hover .qrcode-img {
//   border-color: #2A5CAA;
//   box-shadow: 0 2px 8px rgba(42, 92, 170, 0.15);
  transform: scale(1.05);
}
.qrcode-item:hover .qrcode-name {
  color: #2A5CAA;
}
.qrcode-name {
  font-size: 12px;
  color: #333;
}
.preview-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
}
.preview-img {
  width: 200px;
  height: 200px;
  border-radius: 6px;
  margin-bottom: 12px;
}
.preview-name {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}
</style>
